module.exports = function() {
  return new Worker(__webpack_public_path__ + "961ede08b59d516d4007.worker.js");
};